<template>
    <div class="grow">
        <!-- Change the height attribute to adjust the chart height -->
        <LineChart :data="chartData" width="800" height="300"/>
    </div>
</template>

<script>
import { ref } from 'vue'
import LineChart from '../charts/LineChart03.vue'

// Import utilities
import { tailwindConfig, hexToRGB } from '../utils/Utils'

export default {
    name: 'VideosHistoricalStats',
    components: {
        LineChart,
    },
    props: {
        data: Array,
        labels: Array
    },
    setup(props) {
        const chartData = ref({
            labels: props.labels,
            datasets: [
                // Indigo line
                {
                    label: 'Videos',
                    data: props.data,
                    fill: true,
                    backgroundColor: `rgba(${hexToRGB(tailwindConfig().theme.colors.blue[500])}, 0.08)`,
                    borderColor: tailwindConfig().theme.colors.indigo[500],
                    borderWidth: 2,
                    tension: 0,
                    pointRadius: 0,
                    pointHoverRadius: 3,
                    pointBackgroundColor: tailwindConfig().theme.colors.indigo[500],
                    clip: 20,
                },
            ],
        })

        return {
            chartData,
        }
    },
    created() {
        // this.chartData.labels = this.labels
        // this.chartData.datasets[0].data = this.videos
        // this.chartData.datasets[0].data = this.views
    }
}
</script>
